export default __webpack_public_path__ + "static/media/image_methode_étape1.c1b5c503.jpg";